import { useQuery } from '@tanstack/react-query';
// Service
import { getPassengers } from './customerPassengersService';

/**
 * @description Get the list of passengers of a customer.
 * @param {number} customerId
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<CustomerPassenger[], Error>}
 */
export const useGetPassengerListQuery = (customerId, options) => useQuery({
  queryKey: ['customer-passengers', customerId],
  queryFn: () => getPassengers(customerId),
  ...options,
});
